import { inheritsLoose as _inheritsLoose, extends as _extends, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import OneTimePasscode from '@piconetworks/pkg-otp';
import Boutton from '@piconetworks/pkg-boutton';
import Picon from '@piconetworks/pkg-picon';
import styles from './scss/Otp.module.scss.js';

var _excluded = ["meta", "input"];
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    console.log('getDerivedStateFromError', error);
    return {
      hasError: true
    };
  };
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    console.error(error.message, errorInfo);
  };
  _proto.render = function render() {
    var hasError = this.state.hasError;
    var _this$props = this.props,
      children = _this$props.children,
      _this$props$RenderErr = _this$props.RenderError,
      RenderError = _this$props$RenderErr === void 0 ? function () {
        return /*#__PURE__*/React.createElement("div", {
          className: "errorBoundaree"
        });
      } : _this$props$RenderErr;
    if (hasError) {
      return /*#__PURE__*/React.createElement(RenderError, null);
    }
    return children;
  };
  return ErrorBoundary;
}(React.Component);
var Otp = function Otp(_ref) {
  var checkPhone = _ref.checkPhone,
    confirmCode = _ref.confirmCode,
    customProperties = _ref.customProperties,
    email = _ref.email,
    fieldContainerProps = _ref.fieldContainerProps,
    newsletters = _ref.newsletters,
    oneTimeCodeError = _ref.oneTimeCodeError,
    phoneNumber = _ref.phoneNumber,
    publisherId = _ref.publisherId,
    requestNewCode = _ref.requestNewCode,
    resendOneTimeCode = _ref.resendOneTimeCode;
  var _useState = useState(''),
    currentPasscode = _useState[0],
    setCurrentPasscode = _useState[1];
  var _useState2 = useState(null),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(false),
    showNotification = _useState3[0],
    setShowNotification = _useState3[1];
  useEffect(function () {
    if (showNotification) {
      setTimeout(function () {
        return setShowNotification(false);
      }, 3000);
    }
  }, [showNotification]);
  var friendlyOneTimeCodeError;
  if (!!oneTimeCodeError && oneTimeCodeError !== null && oneTimeCodeError !== void 0 && oneTimeCodeError.includes('The requested resource')) {
    friendlyOneTimeCodeError = 'Unable to verify email. This code is no longer valid.';
  }
  var processCode = async function processCode() {
    try {
      await confirmCode({
        code: currentPasscode,
        email: email,
        customProperties: customProperties,
        selectedNewsletters: newsletters,
        phone: phoneNumber
      });
    } catch (error) {
      console.error(error);
    }
  };
  var onEnterCode = function onEnterCode(e, otpInputsWithValues) {
    if (e.key === 'Enter' || otpInputsWithValues === 6) {
      e.preventDefault();
      processCode();
    }
  };
  var otpInputsEl = document.getElementById('otp-inputs');
  var otpInputs = otpInputsEl && otpInputsEl.getElementsByTagName('input');
  var resendOTP = async function resendOTP() {
    try {
      if (email) {
        await resendOneTimeCode({
          email: email,
          publisherId: publisherId
        });
        Array.from(otpInputs).forEach(function (input) {
          input.value = '';
        });
      }
      if (phoneNumber) {
        await checkPhone({
          phone: phoneNumber
        });
      }
      setShowNotification(true);
    } catch (error) {
      console.log(error);
      setErrorMessage(error.message);
    }
  };
  var otpInputsWithValues = 0;
  useEffect(function () {
    if (otpInputs) {
      Array.from(otpInputs).forEach(function (input) {
        if (input.value) {
          otpInputsWithValues++;
        }
        input.onkeyup = function (e) {
          onEnterCode(e, otpInputsWithValues);
        };
      });
    }
  });
  var renderOTPButton = function renderOTPButton() {
    return /*#__PURE__*/React.createElement(Boutton, {
      variant: "primary",
      onClick: function onClick(e) {
        e.preventDefault();
        processCode();
      },
      disabled: !currentPasscode,
      className: styles.otpButton
    }, "Confirm");
  };
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.field
  }, /*#__PURE__*/React.createElement("label", null, "Enter the code sent to " + (email || phoneNumber) + ".\n                        " + (email ? 'If you don\'t see a verification code in your inbox, please check your filters for spam and updates.' : '')), /*#__PURE__*/React.createElement(Field, _extends({}, fieldContainerProps, {
    name: "code",
    type: "tel",
    autoComplete: "one-time-code"
  }), function (_ref2) {
    var meta = _ref2.meta,
      input = _ref2.input;
      _objectWithoutPropertiesLoose(_ref2, _excluded);
    return /*#__PURE__*/React.createElement("div", {
      className: styles.otpInput,
      id: "otp-inputs"
    }, /*#__PURE__*/React.createElement(OneTimePasscode, {
      className: "otc",
      isErrored: !!oneTimeCodeError,
      isInputNum: true,
      shouldAutoFocus: true,
      numInputs: 6,
      currentPasscode: currentPasscode,
      setCurrentPasscode: setCurrentPasscode,
      input: input,
      meta: meta,
      errorText: friendlyOneTimeCodeError || oneTimeCodeError
    }));
  })), showNotification && /*#__PURE__*/React.createElement("div", {
    className: styles.notification
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Picon, {
    icon: "icon_checkmark",
    size: "24",
    color: "#28bf6f"
  }), "New code sent")), /*#__PURE__*/React.createElement("p", {
    className: styles.info
  }, "Didn\u2019t receive a code? ", ' ', /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      resendOTP();
    },
    className: styles.resendCode
  }, "Resend code"), " or ", ' ', /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return requestNewCode();
    },
    className: styles.backLink
  }, "change contact info"), "."), /*#__PURE__*/React.createElement("div", null, renderOTPButton()), errorMessage && errorMessage));
};
Otp.propTypes = {
  allowSkipOtp: PropTypes.bool,
  checkPhone: PropTypes.func,
  confirmCode: PropTypes.func,
  contrastColor: PropTypes.string,
  email: PropTypes.string,
  fieldContainerProps: PropTypes.any,
  linkColor: PropTypes.string,
  onSkipOtp: PropTypes.func,
  oneTimeCodeError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  oneTimeCodeSent: PropTypes.bool,
  phoneNumber: PropTypes.string,
  publisherId: PropTypes.string,
  requestNewCode: PropTypes.func
};
var MemoizedOtpField = /*#__PURE__*/React.memo(Otp);
MemoizedOtpField.displayName = 'FieldOtp';

export { MemoizedOtpField as default };
//# sourceMappingURL=index.js.map
